/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import StructureOptionsData from '@Services/StructureOptionsData';
import StructureContainers from '@Services/StructureContainers';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectedOptionsNameValueObjectsArray as selectedOptionsNameValueObjectsArraySelector } from '@Containers/StructureOptions/StructureOptionsSelecors';
import { updateStructureOptionsDialog as updateStructureOptionsDialogAction } from '@Containers/StructureOptions/StructureOptionsDialog/StructureOptionsDialogActions';
import { fetchAndCreateInitialOptionsCopy as fetchAndCreateInitialOptionsCopyAction } from '@Containers/StructureOptions/StructureOptionsActions';
import { ButtonWithIcon } from '@els/els-react--button';

import './StructureOptionsBadges.scss';

function StructureOptionsBadges({
  id,
  updateStructureOptionsCallback,
  onSavedOptionsChange = () => {},
  structureOptions,
  savedOptions,
  fetchAndCreateInitialOptionsCopy,
  onStructureOptionClick,
}) {
  const BADGES_IN_ONE_LANE = 3;
  const [badges, setBadges] = useState([]);
  const [ellipsisView, setEllipsisView] = useState(false);
  const [firstBadge, setFirstBadge] = useState(null);
  const [lastBadge, setLastBadge] = useState(null);

  function updateBadges(data) {
    const newBadges = StructureOptionsData.calculateBadges(data);
    setBadges(newBadges);

    if (newBadges.length > BADGES_IN_ONE_LANE) {
      setEllipsisView(true);
      setFirstBadge(newBadges[0]);
      setLastBadge(newBadges[newBadges.length - 1]);
    } else {
      setEllipsisView(false);
    }
  }

  async function updateStructureOptions(optionsList) {
    // Don't update storage if id or optionsList is missing
    if (!id || !optionsList) {
      return;
    }

    onSavedOptionsChange(optionsList);
    StructureOptionsData.restoreOptions(optionsList).then(updateBadges);
    await StructureContainers.updateContainerOptions(id, optionsList).catch(Logger.reject);

    if (typeof updateStructureOptionsCallback === 'function') {
      updateStructureOptionsCallback();
    }
  }

  useEffect(() => {
    if (savedOptions) {
      updateStructureOptions(savedOptions);
    }
  }, [savedOptions]);

  const initialize = async () => {
    if (structureOptions && !savedOptions) {
      fetchAndCreateInitialOptionsCopy(id, structureOptions.length ? structureOptions : undefined).catch(Logger.error);
    } else {
      StructureContainers.getContainerOptions(id)
        .then((data) => {
          fetchAndCreateInitialOptionsCopy(id, data && data.length ? data : undefined);
        })
        .catch(Logger.error);
    }
  };

  useEffect(() => {
    initialize();
  }, []);

  const handleClick = () => {
    if (typeof onStructureOptionClick === 'function') {
      onStructureOptionClick();
    }
  };

  const buttonText = () =>
    (!ellipsisView && badges.map((badge) => <span key={badge}>{badge}</span>)) ||
    (!!ellipsisView && <span>{firstBadge}</span>) ||
    (!!ellipsisView && <span className="ellipsis-tag">...</span>) ||
    (!!ellipsisView && <span>{lastBadge}</span>);

  const badgesAriaText = ellipsisView ? `${firstBadge}, ..., ${lastBadge}` : badges.join(', ');

  return (
    <ButtonWithIcon
      sprite="Edit"
      iconRight
      id="querybuilder-editstructureconfig-button"
      type="link"
      data-e2e="e2e-structure-options-badges-edit-button"
      className="edit-structure-icon"
      aria-label={`Edit structure search settings, current selection is ${badgesAriaText}`}
      onClick={handleClick}>
      <span aria-hidden="true">{buttonText()}</span>
    </ButtonWithIcon>
  );
}

const mapStateToProps = (state, ownProps) => ({
  savedOptions: selectedOptionsNameValueObjectsArraySelector(state, ownProps),
});

const mapDispatchToProps = {
  openStructureOptionsDialog: updateStructureOptionsDialogAction,
  fetchAndCreateInitialOptionsCopy: fetchAndCreateInitialOptionsCopyAction,
};

StructureOptionsBadges.propTypes = {
  id: PropTypes.string,
  onSavedOptionsChange: PropTypes.func,
  structureOptions: PropTypes.array,
  savedOptions: PropTypes.array,
  fetchAndCreateInitialOptionsCopy: PropTypes.func,
  updateStructureOptionsCallback: PropTypes.func,
  onStructureOptionClick: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(StructureOptionsBadges);
